function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.49998 10.8333C5.30831 10.8333 4.33331 11.8083 4.33331 13C4.33331 14.1917 5.30831 15.1667 6.49998 15.1667C7.69165 15.1667 8.66665 14.1917 8.66665 13C8.66665 11.8083 7.69165 10.8333 6.49998 10.8333ZM19.5 10.8333C18.3083 10.8333 17.3333 11.8083 17.3333 13C17.3333 14.1917 18.3083 15.1667 19.5 15.1667C20.6916 15.1667 21.6666 14.1917 21.6666 13C21.6666 11.8083 20.6916 10.8333 19.5 10.8333ZM13 10.8333C11.8083 10.8333 10.8333 11.8083 10.8333 13C10.8333 14.1917 11.8083 15.1667 13 15.1667C14.1916 15.1667 15.1666 14.1917 15.1666 13C15.1666 11.8083 14.1916 10.8333 13 10.8333Z",
  fill: "#9FA2B4"
});

function SvgDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.29e2bdb5.svg";
export { ForwardRef as ReactComponent };